import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Gender Equity Report")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Entity Type", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Start Date ", -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "End Date ", -1)
const _hoisted_18 = { class: "col-md-2 mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "table-responsive" }
const _hoisted_22 = { class: "row w-100 mb-2 mt-5" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_24 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "table table-borderless gy-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Training Institute"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Courses"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Batches"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "3",
      class: "border border-grey text-center"
    }, " Female as % of all Trainees "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "border border-grey text-center"
    }, " as % of all Female Trainees ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Enrollment"),
    /*#__PURE__*/_createElementVNode("th", null, "Certification"),
    /*#__PURE__*/_createElementVNode("th", null, "Job Placement"),
    /*#__PURE__*/_createElementVNode("th", null, "Certification"),
    /*#__PURE__*/_createElementVNode("th", null, "Job Placement")
  ])
], -1)
const _hoisted_33 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }
const _hoisted_34 = {
  style: {"border-top":"1px solid #50cd89 !important"},
  colspan: "11"
}
const _hoisted_35 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_36 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_37 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_38 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_39 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_40 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_41 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_42 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_43 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_44 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_45 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }
const _hoisted_46 = {
  style: {"border-top":"1px solid #50cd89 !important"},
  colspan: "2"
}
const _hoisted_47 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_48 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_49 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_50 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_51 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_52 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_53 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_54 = {
  class: "align-middle",
  style: {"border-top":"1px solid #50cd89 !important"}
}
const _hoisted_55 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}, " Grand Total ", -1)
const _hoisted_57 = {
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}
const _hoisted_58 = {
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}
const _hoisted_59 = {
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}
const _hoisted_60 = {
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}
const _hoisted_61 = {
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}
const _hoisted_62 = {
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}
const _hoisted_63 = {
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}
const _hoisted_64 = {
  class: "align-middle",
  style: {"border-top":"1px solid rgb(80, 205, 137) !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.batch.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Tranche",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  name: "tranche_id",
                  placeholder: "Select Type",
                  modelValue: _ctx.batch.entity_type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_type) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Select Type",
                      value: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Type")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Public",
                      value: "1009"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Public")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Private",
                      value: "1010"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Private")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "NGO",
                      value: "1007"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("NGO")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_el_form_item, {
                  prop: "date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.batch.start_date,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.start_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      type: "date",
                      name: "start_date",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_el_form_item, {
                  prop: "date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.batch.end_date,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.end_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      type: "date",
                      name: "end_date",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getTableData())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_19
                ])
              ])
            ]),
            (_ctx.showTableData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                          title: "Download Xlse",
                          "data-v-54b12dc8": "",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportTrainee()))
                        }, _hoisted_26),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Download PDF",
                          "data-v-54b12dc8": "",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadPdf()))
                        }, _hoisted_28),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Print",
                          "data-v-54b12dc8": "",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.printPdf()))
                        }, _hoisted_30)
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (value, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createElementVNode("tr", _hoisted_33, [
                              _createElementVNode("td", _hoisted_34, _toDisplayString(value?.entity_type), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value?.entity, (entity, index2) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index2 }, [
                                _createElementVNode("td", _hoisted_35, _toDisplayString(entity?.sl), 1),
                                _createElementVNode("td", _hoisted_36, _toDisplayString(entity?.entity_name), 1),
                                _createElementVNode("td", _hoisted_37, _toDisplayString(entity?.institute_count), 1),
                                _createElementVNode("td", _hoisted_38, _toDisplayString(entity?.course_count), 1),
                                _createElementVNode("td", _hoisted_39, _toDisplayString(entity?.batch_count), 1),
                                _createElementVNode("td", _hoisted_40, _toDisplayString(entity?.enroll_female_count.toFixed(2)), 1),
                                _createElementVNode("td", _hoisted_41, _toDisplayString(entity?.certified_female_count.toFixed(2)), 1),
                                _createElementVNode("td", _hoisted_42, _toDisplayString(entity?.employment_female_count.toFixed(2)), 1),
                                _createElementVNode("td", _hoisted_43, _toDisplayString(entity?.female_in_certified_female_count.toFixed(
                                2
                              )), 1),
                                _createElementVNode("td", _hoisted_44, _toDisplayString(entity?.female_in_employment_female_count.toFixed(
                                2
                              )), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", _hoisted_45, [
                              _createElementVNode("td", _hoisted_46, " SubTotals of (" + _toDisplayString(value?.entity_type) + ") ", 1),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(value?.sub_institute_count), 1),
                              _createElementVNode("td", _hoisted_48, _toDisplayString(value?.sub_course_count), 1),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(value?.sub_batch_count), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(value?.sub_total_trainee
                              ? (
                                  (value?.sub_enroll_female_count /
                                    value?.sub_total_trainee) *
                                  100
                                ).toFixed(2)
                              : 0), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(value?.sub_total_certified_trainee
                              ? (
                                  (value?.sub_certified_female_count /
                                    value?.sub_total_certified_trainee) *
                                  100
                                ).toFixed(2)
                              : 0), 1),
                              _createElementVNode("td", _hoisted_52, _toDisplayString(value?.sub_total_placement_trainee
                              ? (
                                  (value?.sub_employment_female_count /
                                    value?.sub_total_placement_trainee) *
                                  100
                                ).toFixed(2)
                              : 0), 1),
                              _createElementVNode("td", _hoisted_53, _toDisplayString(value?.sub_enroll_female_count
                              ? (
                                  (value?.sub_certified_female_count /
                                    value?.sub_enroll_female_count) *
                                  100
                                ).toFixed(2)
                              : 0), 1),
                              _createElementVNode("td", _hoisted_54, _toDisplayString(value?.sub_enroll_female_count
                              ? (
                                  (value?.sub_employment_female_count /
                                    value?.sub_enroll_female_count) *
                                  100
                                ).toFixed(2)
                              : 0), 1)
                            ])
                          ], 64))
                        }), 128)),
                        _createElementVNode("tr", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.total_institute), 1),
                          _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.total_course), 1),
                          _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.total_batch), 1),
                          _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.total_enroll_female_percent), 1),
                          _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.total_certification_female_percent), 1),
                          _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.total_placement_female_percent), 1),
                          _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.total_female_in_female_certified), 1),
                          _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.total_female_in_female_placement), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}